import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  contentBtn: {

    paddingHorizontal: 25,
    width: '100%'
  },
  text: {
    flex: 1,
    padding: 25,
    fontSize: 16,
    lineHeight: 18,
  },
  list: {
    paddingVertical: 15,
    fontSize: 14,
    lineHeight: 20,
  },
  bold: {
    fontWeight: 'bold'
  },
  btn: {
    padding: 10,
    borderRadius: 20
  },
  textBtn: {
    color: '#fff',
    textAlign: 'center',
    fontSize: 18,
    fontWeight: '500'
  }
});

export default styles;
